import _isEmpty from 'lodash/isEmpty';
import { object, array, string } from 'prop-types';
import React from 'react';
import { ThemeProvider } from 'styled-components';

import Table from 'ravenjs/lib/Table';
import { getMergedThemeFromSchema } from 'ravenjs/utils/theme';
import { warning } from 'ravenjs/utils/warning';
import { get, isEmpty } from 'ravenjs/utils/lodash';
import Typography from 'ravenjs/lib/Typography';

import DataListBody from './DataListBody';
import DataListHead from './DataListHead';
import DataListStyled from './DataListStyled';

function DataList(props) {
    const {
        actions,
        data,
        customFirstRowData,
        schema,
        customFirstRowSchema,
        style,
        tableId,
    } = props;
    const label = get(schema, 'label');
    if (_isEmpty(schema)) {
        warning(!_isEmpty(schema), [
            `A <DataList /> requires a 'schema' prop to build the Data List Table.`,
        ]);
        return null;
    }
    const { table: tableProps = {} } = schema;
    const tableCols = get(schema, 'columns', []);
    const hideHead = get(schema, 'hideHead', false);

    return (
        <ThemeProvider theme={getMergedThemeFromSchema(props)}>
            {label && (
                <Typography gutterBottom="20px" type="label" fontWeight="700">
                    {label}
                </Typography>
            )}
            <DataListStyled style={style}>
                <Table cols={tableCols.length || null} {...tableProps} id={tableId}>
                    {!hideHead && <DataListHead actions={actions} data={data} schema={schema} />}
                    {!isEmpty(customFirstRowData) && (
                        <DataListBody
                            actions={actions}
                            data={customFirstRowData}
                            schema={customFirstRowSchema}
                        />
                    )}
                    <DataListBody actions={actions} data={data} schema={schema} />
                </Table>
            </DataListStyled>
        </ThemeProvider>
    );
}

DataList.propTypes = {
    actions: object,
    data: array,
    customFirstRowData: array,
    schema: object,
    customFirstRowSchema: object,
    style: object,
    tableId: string,
};

DataList.defaultProps = {
    actions: null,
    data: null,
    customFirstRowData: null,
    schema: null,
    customFirstRowSchema: null,
    style: null,
    tableId: '',
};

const DataListMemo = React.memo(
    DataList,
    (prevProps, nextProps) => JSON.stringify(prevProps) === JSON.stringify(nextProps)
);

export { DataListMemo };
export default DataList;
